import React from 'react';
import {createRefetchContainer, graphql} from 'react-relay';
import {func, object, shape} from 'prop-types';
import OverlayView from '../OverlayView/OverlayView';
import MobileNavMenuBody from './MobileNavMenuBody';
import MobileNavDrilldown from '../MobileNavDrilldown/MobileNavDrilldown';
import MobileNavAnimationSlide from '../MobileNavAnimations/MobileNavAnimationSlide';
import styles from './mobileNavMenu.scss';
import copy from './mobileNavMenuCopy';
import get from 'lodash.get';

const messagesSection = {
    name: 'Messages',
    path: '/my/conversations/'
};

const ordersSection = {
    name: 'Orders',
    path: '/my/orders/'
};

const accountSection = {
    name: 'Account Information',
    path: '/my/account/'
};

function getVerticalData(navModule) {
    const {categories, name, url: path} = navModule;
    const totalCount = categories
        .map(category => category.count)
        .reduce((prevCount, currCount) => prevCount + currCount);

    const topItem = {
        name: `${copy.seeAll} ${name}`,
        count: totalCount,
        path
    };

    const items = categories.map(category => {
        return {
            name: category.name,
            count: category.count,
            path: `${path}${category.label}/`
        };
    });

    items.unshift(topItem);

    return [{items, name}];
}

function getNonVerticalData(navModule) {
    return navModule.items.filter(item => item.visible && item.type === 'primary');
}

function getModuleIdentifier(module) {
    return module.name.toLowerCase();
}

function findModuleByIdentifier(modules, identifier) {
    return modules.find(module => getModuleIdentifier(module) === identifier);
}
class MobileNavMenu extends React.Component {
    constructor() {
        super();

        this.onMainMenuItemClick = this.onMainMenuItemClick.bind(this);
        this.onBackClick = this.onBackClick.bind(this);

        this.state = {
            activeDrilldown: null,
            isDrilldownOpen: false
        };
    }

    componentDidMount() {
        if (this.getNavModules().length === 0) {
            this.props.relay.refetch();
        }
    }

    onMainMenuItemClick(menuItem) {
        const module = findModuleByIdentifier(this.getNavModules(), getModuleIdentifier(menuItem));

        /**
         * If there's no module found, we assume that the drilldown shouldn't be actived and we just fire the click
         * handler.
         */
        if (module) {
            const drilldownSectionData = module.isVertical ?
                getVerticalData(module) :
                getNonVerticalData(module);

            this.setState({
                isDrilldownOpen: true,
                drilldownSectionData
            });
        } else {
            this.props.handleNavigateAction(menuItem);
        }
    }

    getNavModules() {
        return get(this.props.viewer, 'navigation.modules') || [];
    }

    onBackClick() {
        this.setState({
            isDrilldownOpen: false
        });
    }

    render() {
        const {isDrilldownOpen, drilldownSectionData} = this.state;
        const {onAuthClick, user} = this.props;
        const accountSections = [
            Object.assign({}, messagesSection, {
                count: get(user, 'conversationSummary.totalUnreadConversationCount') || 0
            }),
            ordersSection,
            accountSection
        ];
        const categoriesSections = this.getNavModules();
        const categoriesSection = {
            title: copy.categories,
            items: categoriesSections
        };
        const sections = [categoriesSection, {
            title: copy.account,
            items: user ? accountSections : []
        }];

        return (
            <OverlayView className={`${styles.container} ${styles.isOpen}`}>
                <div className={styles.bodyContainer}>
                    <MobileNavAnimationSlide in={!isDrilldownOpen}>
                        <MobileNavMenuBody
                            user={user}
                            onAuthClick={onAuthClick}
                            className={styles.bodyItem}
                            onItemClick={this.onMainMenuItemClick}
                            sections={sections}
                        />
                    </MobileNavAnimationSlide>
                    <MobileNavAnimationSlide in={isDrilldownOpen} leave="right" appear="right">
                        <MobileNavDrilldown
                            onBackClick={this.onBackClick}
                            sections={drilldownSectionData || []}
                            onItemClick={this.props.handleNavigateAction}
                        />
                    </MobileNavAnimationSlide>
                </div>
            </OverlayView>
        );
    }
};

MobileNavMenu.propTypes = {
    onAuthClick: func.isRequired,
    handleNavigateAction: func.isRequired,
    viewer: object.isRequired,
    user: object,
    relay: shape({
        refetch: func.isRequired
    }).isRequired
};

export default createRefetchContainer(
    MobileNavMenu,
    {
        viewer: graphql`
            fragment MobileNavMenu_viewer on Viewer {
                navigation {
                    modules {
                        name
                        isVertical
                        url
                        items {
                            visible
                            type
                            name
                            items {
                                name
                                url
                            }
                        }
                        categories {
                            name
                            count
                            label
                        }
                    }
                }
            }
        `,
        user: graphql`
            fragment MobileNavMenu_user on User {
                conversationSummary {
                    totalUnreadConversationCount
                }
                ...MobileNavMenuBody_user
            }
        `
    },
    graphql`
        query MobileNavMenuRefetchQuery {
            viewer {
                ...MobileNavMenu_viewer
            }
        }
    `
);



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavMenu/MobileNavMenu.jsx